<script setup>
import { ref, defineProps, computed } from 'vue';
import { useRoute } from 'src/utils/v2_helper/router';
import MButton from 'src/components/MButton/index.vue';
import { MToast } from 'src/components/MToast/index';
import { useDraggable } from 'src/utils/hooks/use-draggable';
import { reqCallWaiter } from 'src/api/fullDineIn';
import { getTable } from 'src/utils/common';
import { useRetry } from 'src/utils/base';
import { use18n, useIns } from 'src/utils/v2_helper/common';

const CALL_WAIT_TIME = 60000;
// PC视图无法拖动
const IS_PC = process.env.CLIENT && document.documentElement.clientWidth >= 768;

const app = useIns();
const { $t } = use18n();
const route = useRoute();

const show = ref(false);
const calling = ref(0);
const callRef = ref();

const { hasDrag } = useDraggable(
  !IS_PC ? callRef : null,
  !IS_PC ? callRef : null,
  ref(true),
  ref(true),
);
const showCall = computed(() => {
  const pages = [
    'products-list',
    'cart',
    'CartConfirm',
    'OnGoing',
    'FullCheckout',
    'FullCashWaiting',
    // 'FullCanceled',
  ];
  const { cart, order } = app.fullDineInTableData;
  const condition =
    (cart?.orderId || order?.orderDetail?.orderId) && app.isFullDineIn;
  return pages.includes(route.name) && condition;
});

function call() {
  if (!hasDrag.value) {
    const tableNumber = getTable();
    // const waitTime = Date.now() - callStamp.value;
    // if (waitTime < CALL_WAIT_TIME) {
    //   const needWait = parseInt((CALL_WAIT_TIME - waitTime) / 1000, 10);
    //   MToast({
    //     msg: $t('fullDinein.callRepeat', { time: needWait }),
    //     position: 'middle',
    //   });
    //   return;
    // }
    // callStamp.value = Date.now();
    if (calling.value) {
      MToast({ msg: $t('fullDinein.calling'), position: 'middle' });
      return;
    }
    calling.value = true;
    useRetry(reqCallWaiter, { params: { tableNumber } })
      .then((res) => {
        if (res.code === 1101) {
          return MToast({
            msg: res.message,
            position: 'middle',
          });
        }
        const needWaitTime = res.data;
        if (!needWaitTime) {
          MToast({ msg: $t('fullDinein.callSucc'), position: 'middle' });
        } else {
          MToast({
            msg: $t('fullDinein.callRepeat', { time: needWaitTime || 0 }),
            position: 'middle',
          });
        }
      })
      .catch(() => {
        MToast({ msg: $t('fullDinein.callErr'), position: 'middle' });
      })
      .finally(() => {
        calling.value = false;
      });
  }
}
</script>

<template>
  <div v-show="showCall">
    <q-dialog v-model="show" position="bottom">
      <div class="content">
        <div class="header">
          Call Waiter
          <i class="iconfont dm-close" @click="show = false" />
        </div>
        <div class="main">
          <img
            class="img"
            src="https://static.bakmigm.co.id/menu/call_success.png"
          />
          <p class="tile">Call Succeeded</p>
          <p class="text">Waiting for the Waiter, Just a moment please</p>
        </div>
        <MButton class="btn" primary @click="show = false">
          <b>Oke</b>
        </MButton>
      </div>
    </q-dialog>
    <div ref="callRef" class="call" @click="call">
      <i class="icon iconfont dm-Bell" />
      <span class="text">{{ $t('fullDinein.callText') }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.call {
  position: absolute;
  right: 10px;
  top: 30%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #374151;
  z-index: 9999;
  .icon {
    width: 40px;
    height: 40px;
    align-self: center;
    border: solid #d1d5db 1px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
    font-size: 20px;
  }
  .text {
    border: solid #d1d5db 1px;
    border-radius: 2px;
    width: 64px;
    word-break: break-word;
    padding: 2px 4px;
    font-size: 12px;
    text-align: center;
    background: #fff;
  }
}

.content {
  padding: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .header {
    align-self: stretch;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
  }

  .main {
    padding: 48px 80px;
    text-align: center;
    .img {
      width: 150px;
    }
    .tile {
      font-size: 18px;
      font-weight: bold;
      margin: 10px 0 4px;
    }
    .text {
      font-size: 18px;
    }
  }
  .btn {
    align-self: stretch;
  }
}
</style>
